export default "__VITE_ASSET__D1Husu0p__"